// module.exports = {
//     apiKey: "AIzaSyCzuNzPtwsA35C7LLqG5GGaXgHFgyTpzjA",
//     authDomain: "pingpong-32ba1.firebaseapp.com",
//     databaseURL: "https://pingpong-32ba1.firebaseio.com",
//     storageBucket: "pingpong-32ba1.appspot.com",
//     messagingSenderId: "1002315054645"
//   };

  module.exports = {
    apiKey: "AIzaSyCzuNzPtwsA35C7LLqG5GGaXgHFgyTpzjA",
    authDomain: "pingpong-32ba1.firebaseapp.com",
    databaseURL: "https://pingpong-32ba1.firebaseio.com",
    storageBucket: "pingpong-32ba1.appspot.com",
    messagingSenderId: "1002315054645"
  };


//////////////////
// WEBPACK FOOTER
// ./fbconfig.js
// module id = 82
// module chunks = 0